export default __webpack_public_path__ + "static/media/Sign_in_image.93863629.jpg";